// Supabase auth storage adapter backed by @capacitor/preferences (native
// UserDefaults on iOS). Used instead of localStorage in the native shell:
// iOS can evict WKWebView localStorage under storage pressure, which would
// randomly log users out (roadmap A2). Supabase accepts async storage.
//
// Anything that needs the access token must go through
// supabase.auth.getSession() — never read the storage key directly.
import { Preferences } from '@capacitor/preferences';

export const preferencesStorage = {
  getItem: async (key) => {
    const { value } = await Preferences.get({ key });
    return value ?? null;
  },
  setItem: async (key, value) => {
    await Preferences.set({ key, value });
  },
  removeItem: async (key) => {
    await Preferences.remove({ key });
  },
};
